import { defineMessages } from 'react-intl';

export default defineMessages({
  people: {
    id: 'cboard.components.Settings.People.people',
    defaultMessage: 'People'
  },
  name: {
    id: 'cboard.components.Settings.People.name',
    defaultMessage: 'Name'
  },
  nameSecondary: {
    id: 'cboard.components.Settings.People.nameSecondary',
    defaultMessage: 'Update your user name'
  },
  email: {
    id: 'cboard.components.Settings.People.email',
    defaultMessage: 'Email'
  },
  emailSecondary: {
    id: 'cboard.components.Settings.People.emailSecondary',
    defaultMessage: 'Update your user email'
  },
  language: {
    id: 'cboard.components.Settings.People.language',
    defaultMessage: 'Language'
  },
  languageSecondary: {
    id: 'cboard.components.Settings.People.languageSecondary',
    defaultMessage: 'Let us know what is your language'
  },
  birthdate: {
    id: 'cboard.components.Settings.People.birthdate',
    defaultMessage: 'Birth Date'
  },
  birthdateSecondary: {
    id: 'cboard.components.Settings.People.birthdateSecondary',
    defaultMessage: 'Update your birth date'
  },
  location: {
    id: 'cboard.components.Settings.People.location',
    defaultMessage: 'Location'
  },
  logout: {
    id: 'cboard.components.Settings.People.logout',
    defaultMessage: 'Logout'
  },
  deleteAccountPrimary: {
    id: 'cboard.components.Settings.People.deleteAccountPrimary',
    defaultMessage: 'Delete this account'
  },
  deleteAccountSecondary: {
    id: 'cboard.components.Settings.People.deleteAccountSecondary',
    defaultMessage:
      'Once you delete an account, there is no going back. Please be certain.'
  },
  deleteAccountFinal: {
    id: 'cboard.components.Settings.People.deleteAccountFinal',
    defaultMessage: 'To confirm, type "{deleteAccount}".'
  },
  errorDeletingAccount: {
    id: 'cboard.components.Settings.People.errorDeletingAccount',
    defaultMessage:
      'An error ocurs during Account deletion. please try it again.'
  },
  deleteAccountConfirmation: {
    id: 'cboard.components.Settings.People.deleteAccountConfirmation',
    defaultMessage:
      'Once you delete an account, there is no going back. Are you sure to delete your account?.'
  },
  cancelDeleteAccount: {
    id: 'cboard.components.Settings.People.cancelDeleteAccount',
    defaultMessage: 'Cancel'
  }
});
